module.exports = "/images/no-tags.svg?88f2da6d8a17acadd23f5f12e2075c17";